module.exports = __webpack_public_path__ + "static/media/icon_attention.b10d95d4.svg";